import React from 'react';
import PropTypes from "prop-types";

import {Button} from 'reactstrap';

import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";
import UniversalModalOverride from "components/UniversalModalOverride";


export default class TransactionExport extends React.Component {
	static propTypes = {
		object: PropTypes.object.isRequired,
		properties: PropTypes.object.isRequired,
		locations: PropTypes.array.isRequired,
		history: PropTypes.object.isRequired,
		shouldLoad: PropTypes.bool.isRequired,
		afterExportSave: PropTypes.func.isRequired,
		onSelectUpdate: PropTypes.func.isRequired,
	};

	constructor(props, context) {
		super(props, context);
		this.state = {
			id: null,
			binary_id: null,
			object: null,
			exportModalOpen: false,
		};
	}

	handleToggleExportModal = () => {
		this.setState({exportModalOpen: !this.state.exportModalOpen});
	}

	handleAddExportClick = () => {
		this.setState({
			id: null,
			binary_id: null,
			object: null
		});

		this.handleToggleExportModal();
	}

	handleEditExportClick = () => {
		/** @type {Transactions_Collections_Object} object */
		let object = this.props.object;

		this.setState({
			id: object.exporter,
			binary_id: object.exporter_binary_id,
			object: object.exports,
		});

		this.handleToggleExportModal();
	}

	render() {
		/** @type {Transactions_Collections_Object} object */
		let object = this.props.object;
		let {properties, shouldLoad, afterExportSave, onSelectUpdate} = this.props;
		let {exportModalOpen} = this.state;

		return (
			<div>
				<div className={'form-group'}>
					<div className="row">
						<div className="col-3">
							<span className="input-label">Exporter</span>
							<UniversalModalOverride
								locations={this.props.locations}
								states={this.props.states}
								history={this.props.history}
								id={this.state.id}
								binary_id={this.state.binary_id}
								name={"Exporter"}
								object={Objects.Export}
								objectProps={{
									object: this.state.object
								}}
								showModal={exportModalOpen}
								handleToggle={this.handleToggleExportModal}
								afterSave={afterExportSave}
							/>
						</div>
						<div className="col-9 d-flex">
							<Button
								onClick={this.handleAddExportClick}
								className={"select-add"}
								size={"sm"}
								outline color="primary"
							>
								<i className="fa fa-plus"/>
							</Button>
							{object.exporter ?
								<Button
									onClick={this.handleEditExportClick}
									className={"select-add"}
									size={"sm"}
									outline color="green-meadow"
								>
									<i className="fa fa-pencil"/>
								</Button>
								: null
							}
							<div className={'flex-grow-1'}>
								<Framework.Elements.Select
									shouldLoad={shouldLoad}
									property={properties.exporter}
									value={object.exporter}
									binary_id={object.exporter_binary_id}
									error={object.exporter_error}
									object={object.exports}
									update={onSelectUpdate}
									text={'name'}
									nullable={true}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

